import styled from 'styled-components';

import { Stack } from '@components/stack';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type HeaderProps = {
  actions?: JSX.Element;
  breadcrumbs?: JSX.Element;
  tabs?: JSX.Element;
  backAction?: JSX.Element;
  title?: JSX.Element;
  selectionHeader?: JSX.Element;
  showSelectionHeader?: boolean;
  hideTabs?: boolean;
};

export const Header = ({
  actions,
  breadcrumbs,
  tabs,
  backAction,
  title,
  selectionHeader,
  showSelectionHeader = false,
  hideTabs = false,
}: HeaderProps) => {
  const hasTabs = Boolean(tabs) && !hideTabs;
  return (
    <Container $hasTabs={hasTabs} $isSelection={showSelectionHeader} id="header">
      {showSelectionHeader ? (
        selectionHeader
      ) : (
        <>
          <InnerContainer hasTabs={hasTabs}>
            <Stack space={2} orientation="horizontal" align="center">
              {backAction}
              {title ?? <Breadcrumbs>{breadcrumbs}</Breadcrumbs>}
            </Stack>
            {tabs && !hideTabs && <TabsContainer>{tabs}</TabsContainer>}
          </InnerContainer>
          <HeaderActions id="header-actions">{actions}</HeaderActions>
        </>
      )}
    </Container>
  );
};

const HeaderHeightWithTabs = '7.5rem';
export const HeaderHeightDefault = '5.5rem';

const Container = styled.div<{ $hasTabs: boolean; $isSelection: boolean }>(
  ({ $hasTabs, $isSelection }) => ({
    display: 'flex',
    padding: pxToRem(24),
    paddingBottom: $hasTabs ? '0' : pxToRem(24),
    transition: 'min-height 0.2s ease-out',
    justifyContent: 'space-between',
    minHeight: $hasTabs ? HeaderHeightWithTabs : HeaderHeightDefault,
    backgroundColor: $isSelection
      ? theme.color.backgroundSecondary
      : theme.color.backgroundLightDark,
    borderBottom: `${pxToRem(1)} solid ${
      $isSelection ? theme.color.uiTrans10 : theme.color.border10
    }`,
    zIndex: 10,
  })
);

const InnerContainer = styled.div<{ hasTabs: boolean }>(({ hasTabs }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: hasTabs ? 'space-between' : 'center',
}));

const Breadcrumbs = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  height: '2.5rem',
});

const TabsContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
});

export const HeaderActions = styled.div({
  flexGrow: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  position: 'relative',
  alignItems: 'flex-start',
});
